"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const config_service_1 = require("../../../shared/config/config.service");
const opportunity_1 = require("../shared/models/opportunity/opportunity");
const enums_1 = require("../@shared-types/opportunites/enums");
const interface_service_1 = require("../../../shared/interface/interface.service");
const resource_1 = __importDefault(require("../shared/models/resource/resource"));
const tab_service_1 = require("../../../shared/browser-functions/tab.service");
const vehicle_1 = require("../shared/models/vehicle/vehicle");
const users_service_1 = require("../../../shared/users/users.service");
const web_socket_service_1 = require("../../../shared/connections/web-socket.service");
const enums_2 = require("../@shared-types/socket/enums");
let OpportunityComponent = class OpportunityComponent {
    constructor(opportunityModel, configService, interfaceService, resourceModel, tabService, vehicleModel, usersService, socketService) {
        this.opportunityModel = opportunityModel;
        this.configService = configService;
        this.interfaceService = interfaceService;
        this.resourceModel = resourceModel;
        this.tabService = tabService;
        this.vehicleModel = vehicleModel;
        this.usersService = usersService;
        this.socketService = socketService;
        this.opportunityId = null;
        this.opportunity = null;
        this.data = null;
        this.activities = null;
        this.vehicle = null;
        this.userIsExternal = false;
        /** Controls visbility of forms and their required data */
        this.forms = {
            visibility: {
                customerForm: false,
                stateForm: false,
                emailForm: false,
                offerSendingForm: false,
                assignmentForm: false,
                actionsSheet: false,
                noteForm: false,
            },
            data: {
                stateForm: null,
                offerSendingForm: null,
                emailFormSubject: null,
                emailFormContent: null,
            },
        };
        /** Convert our state into a progess to better work in UI */
        this.opportunityStates = [];
        /** After some events we need to reload the whole page:
         * (after customer data was changed) */
        this.reload = () => {
            window.location.reload();
        };
        this.navigateToVehicle = (vehicleId, params, redirect, dummyVehicle) => {
            const seachParams = Object.assign({ id: vehicleId }, params);
            if (redirect)
                seachParams.redirect = this.interfaceService.getPath();
            if (dummyVehicle) {
                this.interfaceService.navigateToUrl('/vehicles/dummy', seachParams);
            }
            else {
                this.interfaceService.navigateToUrl('/vehicles/stock', seachParams);
            }
        };
        this.updateState = (update) => __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunityId)
                return;
            yield this.opportunityModel.update(this.opportunityId, update);
            this.ngOnInit();
        });
        this.showOffer = (offerId) => __awaiter(this, void 0, void 0, function* () {
            const offer = yield this.resourceModel.getResource(offerId);
            this.tabService.openTabWithHTML(offer, 'Vorschau Angebot', false);
        });
        this.openHTMLTab = (html) => {
            this.tabService.openTabWithHTML(Buffer.from(html, 'base64').toString('utf-8'), 'E-Mail', false);
        };
        this.showForm = (form) => {
            this.forms.visibility[form] = true;
        };
        /** We don't supply the form to hide, but insetad need to find the key
         * where `visibility` is true and hide that form.
         * Some forms require to load the displayed data again. */
        this.hideForm = () => {
            const firstTrueKey = (obj) => (Object.entries(obj).find(([_, value]) => value) || [undefined])[0];
            const visibleFormKey = firstTrueKey(this.forms.visibility);
            if (!visibleFormKey)
                return;
            this.forms.visibility[visibleFormKey] = false;
            switch (visibleFormKey) {
                case 'stateForm':
                case 'emailForm':
                case 'offerSendingForm':
                case 'assignmentForm':
                case 'noteForm':
                    this.ngOnInit();
                    break;
                case 'customerForm':
                    this.reload();
                    break;
                default: break;
            }
            this.forms.data = {
                stateForm: null,
                offerSendingForm: null,
                emailFormSubject: null,
                emailFormContent: null,
            };
        };
        this.decodeBase64 = (encoded) => Buffer.from(encoded, 'base64').toString('utf-8');
        const { opportunityId } = this.configService.getRouteParams();
        if (opportunityId)
            this.opportunityId = opportunityId;
        this.userIsExternal = this.usersService.userIsExternal();
        this.socketService.on(enums_2.EWebSocketMessage.OPPORTUNITY_UPDATE, (data) => {
            const updateData = JSON.parse(data);
            if (updateData.opportunityId !== this.opportunityId)
                return;
            this.ngOnInit();
        });
    }
    /** The server is queried to return all data associated
     * with an Opportunity: infos, offer, reservations etc.
     * Here we will add all data into `activities` to shown them
     * sorted by date in the app.
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunityId)
                return;
            this.activities = [];
            this.data = null;
            this.opportunity = yield this.opportunityModel.get(this.opportunityId);
            this.data = yield this.opportunityModel.getData(this.opportunityId);
            // Add offers to activities
            this.data.offers.forEach((o) => {
                var _a, _b;
                const customerInfos = (_a = this.data) === null || _a === void 0 ? void 0 : _a.infos.filter((i) => i.type === enums_1.EOpportunityInfoType.OFFER_RESPONSE && i.data).filter((i) => i.data.offerId === o.id);
                (_b = this.activities) === null || _b === void 0 ? void 0 : _b.push({
                    type: 'OFFER',
                    data: o,
                    creationDate: o.creationDate,
                    infos: customerInfos || [],
                });
            });
            // Add notes to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.NOTE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'NOTE', data: i, creationDate: i.creationDate }); });
            // Add reservations to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.RESERVATION)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'RESERVATION', data: i, creationDate: i.creationDate }); });
            // Add sales to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.SALE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'SALE', data: i, creationDate: i.creationDate }); });
            // Add reservations to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.AVAILABLE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'AVAILABLE', data: i, creationDate: i.creationDate }); });
            // Add files from templates to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.TEMPLATE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'TEMPLATE', data: i, creationDate: i.creationDate }); });
            // Add state changes to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.STATE_CHANGE)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'STATE_CHANGE', data: i, creationDate: i.creationDate }); });
            // Add leads to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.LEAD)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'LEAD', data: i, creationDate: i.creationDate }); });
            // Add assignments to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.ASSIGNMENT)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'ASSIGNMENT', data: i, creationDate: i.creationDate }); });
            // Add incoming emails to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.EMAIL_INCOMING)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'INCOMING_EMAIL', data: i, creationDate: i.creationDate }); });
            // Add outgoging emails to activities
            this.data.infos
                .filter((i) => i.type === enums_1.EOpportunityInfoType.EMAIL_OUTGOING)
                .forEach((i) => { var _a; return (_a = this.activities) === null || _a === void 0 ? void 0 : _a.push({ type: 'OUTGOING_EMAIL', data: i, creationDate: i.creationDate }); });
            this.activities
                .sort((a, b) => new Date(b.creationDate).valueOf() - new Date(a.creationDate).valueOf());
            this.vehicle = yield this.vehicleModel.get(this.opportunity.vehicleId);
            this.opportunityStates = this.mapOpportunityState(this.opportunity.state, this.opportunity.userId);
        });
    }
    mapOpportunityState(state, assignee) {
        switch (state) {
            case enums_1.EOpportunityState.NEW:
                if (assignee) {
                    return [
                        { name: 'Neu', done: true, colorClass: 'primary-inversed' },
                        { name: 'Zugeteilt', done: false, colorClass: 'primary' },
                        { name: 'In Bearbeitung', done: false, colorClass: 'gray' },
                        { name: 'Geschlossen', done: false, colorClass: 'gray' },
                    ];
                }
                return [
                    { name: 'Neu', done: false, colorClass: 'primary' },
                    { name: 'Zugeteilt', done: false, colorClass: 'gray' },
                    { name: 'In Bearbeitung', done: false, colorClass: 'gray' },
                    { name: 'Geschlossen', done: false, colorClass: 'gray' },
                ];
            case enums_1.EOpportunityState.OPEN:
                return [
                    { name: 'Neu', done: true, colorClass: 'primary-inversed' },
                    { name: 'Zugeteilt', done: true, colorClass: 'primary-inversed' },
                    { name: 'In Bearbeitung', done: false, colorClass: 'primary' },
                    { name: 'Geschlossen', done: false, colorClass: 'gray' },
                ];
            case enums_1.EOpportunityState.CLOSED:
                return [
                    { name: 'Neu', done: true, colorClass: 'primary-inversed' },
                    { name: 'Zugeteilt', done: true, colorClass: 'primary-inversed' },
                    { name: 'In Bearbeitung', done: true, colorClass: 'primary-inversed' },
                    { name: 'Geschlossen', done: false, colorClass: 'primary' },
                ];
            case enums_1.EOpportunityState.POSTPONED:
                return [
                    { name: 'Neu', done: true, colorClass: 'primary-inversed' },
                    { name: 'Zugeteilt', done: true, colorClass: 'primary-inversed' },
                    { name: 'Zurückgestellt', done: false, colorClass: 'primary' },
                    { name: 'Geschlossen', done: false, colorClass: 'gray' },
                ];
            default:
                return [];
        }
    }
};
OpportunityComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity',
        templateUrl: require('./opportunity.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _a : Object, typeof (_b = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _b : Object, typeof (_c = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _c : Object, typeof (_d = typeof resource_1.default !== "undefined" && resource_1.default) === "function" ? _d : Object, typeof (_e = typeof tab_service_1.TabService !== "undefined" && tab_service_1.TabService) === "function" ? _e : Object, typeof (_f = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _f : Object, typeof (_g = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _g : Object, typeof (_h = typeof web_socket_service_1.SocketService !== "undefined" && web_socket_service_1.SocketService) === "function" ? _h : Object])
], OpportunityComponent);
exports.default = OpportunityComponent;
